var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasImage)?_c('CycleContentBlock',{attrs:{"centered":""},scopedSlots:_vm._u([{key:"image",fn:function(){return [_c('CycleImage',{attrs:{"image":_vm.image,"modifier":"logo"}})]},proxy:true}],null,false,3987162110)}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }